<template>
<div class="d-input-group input-group" :class="[{ disabled: disabled }, _variant]">
    <span v-if="title" class="title">{{ title }}</span>
    <div class="input-field d-flex w-100 align-content-center">
        <select class="form-select shadow-none flex-grow-1" aria-label="Small" aria-describedby="inputGroup-sizing-default" v-model="model" :disabled="disabled" :placeholder="_placeholder" @change="OnChange()" @keydown.enter="OnEnter()" >
            <option v-for="item in the_items" :value="item.value" :key="item.value">{{ _translate(item.text) }}</option>
        </select>
    </div>
    <span v-if="message" class="message" :class="_message_color_class">{{ message }}</span>
</div>
</template>

<script setup>
import {computed, defineEmits, defineModel, defineProps } from 'vue';

import { useTranslationsStore } from '@/dod/store/dtranslations';
const translationsStore = useTranslationsStore(); // Use the globally registered store


const emit = defineEmits(['change', 'enter', 'click']);
const props = defineProps({
    items: {
        type: Array,
        required: true
    },
    title: {
        type: String,
        required: false,
        default: ''
    },
    message: {
        type: String,
        required: false
    },
    placeholder: {
        type: String,
        required: false,
        default: '...'
    },
    disabled: {
        type: Boolean,
        required: false
    },
    variant: {
        type: String,
        required: false
    },
})

const _variant = computed(() => {
  return props.variant ?? '';
});

const _message_color_class = computed(() => {
  if (!_variant.value) return;

  return 'text-' + _variant.value;
});

const the_items = computed(() => {
  return props.items.map(item => {
    if (typeof item === 'object' && item !== null && 'text' in item && 'value' in item) {
      // Already the correct format
      return item;
    } else {
      // Assume it's a string or number
      return {
        text: String(item),
        value: item
      };
    }
  });
});

const _placeholder = computed(() => translationsStore.translate(props.placeholder))

// FUNCTIONS

function _translate(text) {
  return translationsStore.translate(text);
}

const OnChange = () => {
  emit('change', model);
};

const OnEnter = () => {
  emit('enter', model);
};

const model = defineModel();
</script>
